import { useMutation, useQueryClient } from 'react-query';
import HudVoucherService from '../../services/hudVoucherService';
import { VOUCHER_SUBMISSION_STATUS } from '../../constants/hudVoucher';

const useMarkVoucherAsPaidMutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  setSubmissionStatusOverride,
  invalidateVoucherDetailQueries,
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    () => {
      const service = new HudVoucherService();
      return service.markVoucherAsPaid(
        organizationId,
        propertyId,
        hudVoucherId,
      );
    },
    {
      onSuccess: async () => {
        setSubmissionStatusOverride(VOUCHER_SUBMISSION_STATUS.PAID);
        await invalidateVoucherDetailQueries();
        await queryClient.invalidateQueries('hudVouchers');
      },
    },
  );
};

export default useMarkVoucherAsPaidMutation;
